import { render, staticRenderFns } from "./NewsReal.vue?vue&type=template&id=34172dc6&scoped=true&"
import script from "./NewsReal.vue?vue&type=script&lang=ts&"
export * from "./NewsReal.vue?vue&type=script&lang=ts&"
import style0 from "./NewsReal.vue?vue&type=style&index=0&id=34172dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34172dc6",
  null
  
)

export default component.exports